export default __webpack_public_path__ + "static/media/1895.110933e8.png";